<template>
  <el-card class="notice-detail">
    <p class="title">{{ $t('customer::customers-notice::activity_info') }}</p>
    <el-form
      class="edit-form"
      :hide-required-asterisk="true"
      label-width="100px"
      inline
      ref="email"
      :model="emailModel"
      :rules="rules"
    >
      <el-form-item :label="$t('customer::customers-notice::avtivity_name')" prop="name">
        <el-input v-model="activityName" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item :label="$t('customer::customers-notice::email')" prop="accountId">
        <el-select
          v-model="emailModel.accountId"
          :placeholder="$t('customer::customers-notice::please_select')"
          style="width: 200px"
        >
          <el-option v-for="item in emailList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('customer::customers-notice::recipient')" prop="filterValue">
        <el-select
          v-model="emailModel.filter"
          :placeholder="$t('customer::customers-notice::please_select')"
          style="width: 120px"
          @change="changeReceiverType"
        >
          <el-option
            v-for="(item, index) in receiverType"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="emailModel.filterValue"
          :multiple="isMultiple"
          :placeholder="$t('customer::customers-notice::please_select')"
          style="width: 200px"
          v-if="emailModel.filter !== 0"
        >
          <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="isDelay">
        <div slot="label" style="display: inline-block">
          {{ $t('customer::customers-notice::delay_send') }}
          <el-tooltip class="item" effect="dark" placement="bottom">
            <span slot="content">
              {{ $t('customer::customers-notice::after_click_info') }}
            </span>
            <i class="icon-a-01wenhao iconfont-el"></i>
          </el-tooltip>
        </div>
        <el-switch v-model="emailModel.isDelay" @change="clear"></el-switch>
        <div v-if="emailModel.isDelay">
          <el-date-picker
            v-model="emailModel.date"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="pickerDate"
            :placeholder="$t('customer::customers-notice::select_date')"
            style="width: 160px"
          ></el-date-picker>
          <el-time-select
            :disabled="!emailModel.date"
            v-model="emailModel.time"
            :picker-options="pickerTime"
            :placeholder="$t('customer::customers-notice::select_time')"
            style="width: 160px"
          ></el-time-select>
        </div>
      </el-form-item>
      <el-form-item style="width: 100%; margin-left: -10px" prop="content">
        <p class="title">{{ $t('customer::customers-notice::emial_content') }}</p>
        <RichEditor v-model="emailModel.content" :placeholder="$t('customer::customers-notice::content')" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button type="info" @click="submitForm(0)" :loading="saveLoading">
        {{ $t('customer::customers-notice::in_draft') }}
      </el-button>
      <el-button type="primary" @click="submitForm">{{ $t('customer::customers-notice::send') }}</el-button>
    </div>
    <sendDialog v-model="isShowSend" :emailModel="sendParams" @save="$router.go(-1)"></sendDialog>
  </el-card>
</template>

<script>
import RichEditor from '@/components/rich-editor'
import moment from 'moment'
import { getDicByCode } from '@/server/common'
import { STEP_STAUTS } from '../config'
import { getSendEmailList, addEmailModule, getEmailDetail, updateEmailModule } from '@/server/customers'
import sendDialog from './components/sendDialog'
export default {
  components: {
    RichEditor,
    sendDialog,
  },
  data() {
    let validateFilterValue = (rule, value, callback) => {
      if (this.emailModel.filter !== 0) {
        const dict = {
          1: this.$t('customer::customers-notice::level'),
          2: this.$t('customer::customers-notice::tag'),
          3: this.$t('customer::customers-notice::count'),
        }
        if (value === '') {
          callback(new Error(`请选择${dict[this.emailModel.filter]}`))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    let validateCreateTime = (rule, value, callback) => {
      if (this.emailModel.isDelay) {
        if (this.emailModel.date === '') {
          callback(new Error(this.$t('customer::customers-notice::placeholder_date')))
        } else if (this.emailModel.time === '') {
          callback(new Error(this.$t('customer::customers-notice::placeholder_time')))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      isShowSend: false,
      pickerDate: {
        disabledDate: time => {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000
        },
      },
      receiverType: [
        { label: this.$t('customer::customers-notice::all_user'), value: 0 },
        { label: this.$t('customer::customers-notice::level'), value: 1 },
        { label: this.$t('customer::customers-notice::tag'), value: 2 },
        { label: this.$t('customer::customers-notice::count'), value: 3 },
      ],
      tagList: [],
      levelList: [],
      emailList: [],
      stepList: [
        { label: this.$t('customer::customers-notice::zero_time'), value: 0 },
        { label: this.$t('customer::customers-notice::one_time'), value: 1 },
        { label: this.$t('customer::customers-notice::over_one_time'), value: 2 },
        { label: this.$t('customer::customers-notice::second_time'), value: 3 },
      ],
      emailModel: {
        name: '',
        accountId: '',
        filter: 0,
        filterValue: [],
        time: '',
        date: '',
        isDelay: false,
        content: '',
      },
      isMultiple: false, //防止el-select 切换多选属性时报错
      rules: {
        name: [{ required: true, message: this.$t('customer::customers-notice::placeholder_name'), trigger: 'blur' }],
        content: [
          { required: true, message: this.$t('customer::customers-notice::placeholder_content'), trigger: 'blur' },
        ],
        accountId: [
          { required: true, message: this.$t('customer::customers-notice::placeholder_email'), trigger: 'change' },
        ],
        filterValue: [{ required: true, validator: validateFilterValue, trigger: 'blur' }],
        isDelay: [{ required: true, validator: validateCreateTime, trigger: 'blur' }],
      },
      saveLoading: false,
      sendParams: {},
    }
  },
  computed: {
    pickerTime() {
      let start = ''
      if (moment().format('mm') > 30) {
        start = `${Number(moment().format('HH')) + 1}:00`
      } else if (moment().format('mm') < 30 && moment().format('mm') > 0) {
        start = `${moment().format('HH')}:30`
      } else {
        start = moment().format('HH:mm')
      }
      if (this.emailModel.date === moment().format('YYYY-MM-DD')) {
        return {
          start: start,
          step: '00:30',
          end: '24:00',
        }
      } else {
        return {
          start: '00:00',
          step: '00:30',
          end: '24:00',
        }
      }
    },
    options() {
      switch (this.emailModel.filter) {
        case 0:
          return []
        case 1:
          return this.levelList
        case 2:
          return this.tagList
        case 3:
          return this.stepList
        default:
          return []
      }
    },
    activityName: {
      get: function () {
        return this.emailModel.name
      },
      // setter
      set: function (newValue) {
        this.emailModel.name = newValue.toString().slice(0, 30)
      },
    },
  },
  mounted() {
    this.getCustomerTag()
    this.getCustomerLevel()
    this.getSendEmailList()
    if (this.$route.params.id) {
      this.getEmailDetail(this.$route.params.id)
    }
  },
  methods: {
    async getCustomerTag() {
      const { data } = await getDicByCode(8)
      if (data.code === this.$code) {
        this.tagList = data.data.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    },
    async getCustomerLevel() {
      const { data } = await getDicByCode(9)
      if (data.code === this.$code) {
        this.levelList = data.data.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    },
    async getSendEmailList() {
      const { data } = await getSendEmailList()
      if (data.code === this.$code) {
        this.emailList = data.data.map(item => {
          return { label: item.inUser, value: item.id }
        })
      }
    },
    async getEmailDetail(id) {
      const { data } = await getEmailDetail({ id: id })
      if (data.code === this.$code) {
        this.emailModel = { ...this.emailModel, ...data.data }
        if (this.emailModel.delayToSendDate) {
          this.emailModel.date = data.data.delayToSendDate.split(' ')[0]
          this.emailModel.time = data.data.delayToSendDate.split(' ')[1]
          this.emailModel.isDelay = true
        }
        if (this.emailModel.filter === 1 || this.emailModel.filter === 2) {
          this.emailModel.filterValue = this.emailModel.filterValue.split(';').map(el => Number(el))
        }
      }
    },
    changeReceiverType() {
      const multiple = !!(this.emailModel.filter === 1 || this.emailModel.filter === 2)
      this.$set(this.emailModel, 'filterValue', multiple ? [] : '')
      this.$nextTick(() => {
        this.isMultiple = multiple
      })
    },
    submitForm(status) {
      // status 0 存草稿  不传为 保存
      this.$refs.email.validate(valid => {
        if (valid) {
          let obj = { ...this.emailModel }
          if (status === 0) {
            obj.status = 0
          }
          if (obj.isDelay) {
            obj.delayToSendDate = obj.date + ' ' + obj.time + ':00'
          } else {
            delete obj.delayToSendDate
          }
          delete obj.date
          delete obj.time
          delete obj.isDelay
          if (obj.filter !== 0 && obj.filter !== 3) {
            obj.filterValue = obj.filterValue.join(';')
          }
          // 存草稿可以直接存，发送需要弹框
          if (status === 0) {
            // 判断新增还是编辑
            if (this.$route.params.id) {
              this.update(obj)
            } else {
              this.send(obj)
            }
          } else {
            this.sendParams = { ...obj }
            this.isShowSend = true
          }
        }
      })
    },
    async send(obj) {
      this.saveLoading = true
      const { data } = await addEmailModule(obj)
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
        this.$router.go(-1)
      }
      this.saveLoading = false
    },
    // 存草稿
    async update(obj) {
      this.saveLoading = true
      const { data } = await updateEmailModule(obj)
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
        this.$router.go(-1)
      }
      this.saveLoading = false
    },
    clear(val) {
      if (!val) {
        this.emailModel.date = ''
        this.emailModel.time = ''
        this.$refs.email.clearValidate('isDelay')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.notice-detail {
  .title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .edit-form {
    margin-left: 10px;
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    ::v-deep.el-form-item {
      width: 48%;
      margin-bottom: 20px;
    }
    ::v-deep.el-form-item__label {
      color: inherit;
    }
  }
  .dialog-footer {
    text-align: end;
  }
}
</style>
